import { subscribeContestIdsWithPublishedSchedules } from "../services/schedulesService";
import { useEffect, useState } from "react";

type CompetitionLike = { id: string };

/**
 * Zbiór `contestId` turniejów z co najmniej jednym opublikowanym harmonogramem.
 * Nasłuch pod `contests/{id}/schedules` (tylko dla ID z listy) — bez `collectionGroup("schedules")`,
 * bo w bazie jest też root `schedules/` i reguły dla anonima psują globalne zapytanie.
 */
export function usePublishedScheduleContestIds(competitions: readonly CompetitionLike[]) {
  const [contestIds, setContestIds] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const idsKey = Array.from(new Set(competitions.map((c) => c.id).filter(Boolean)))
    .sort()
    .join("|");

  useEffect(() => {
    setError(null);

    const ids = idsKey.length > 0 ? idsKey.split("|") : [];

    if (ids.length === 0) {
      setContestIds(new Set());
      setLoading(false);
      return;
    }

    setLoading(true);

    const unsubscribe = subscribeContestIdsWithPublishedSchedules(
      ids,
      (next) => {
        setContestIds(next);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, [idsKey]);

  return { contestIds, loading, error };
}
